import axios from "axios";
import { getHeaders } from "../utils/main";
import endpoints from "./endpoints";

export const getCountryApi = async params => {
    const callResponse = await axios({
        url: endpoints.countryFetch,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const CreateCountryApi = async data => {
    const callResponse = await axios({
        url: endpoints.Createcountry,
        method: "post",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const DeleteCountryApi = async data => {
    const callResponse = await axios({
        url: endpoints.Deletecountry,
        method: "delete",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const UpdateCountryApi = async data => {
    const callResponse = await axios({
        url: endpoints.Updatecountry,
        method: "patch",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const CountryFindByIdApi = async params => {
    const callResponse = await axios({
        url: endpoints.countryById,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};